import { r, createSender } from '@/plugins/resource/resource'

const MODEL = 'registration'

const AGENT_MODEL = MODEL + '/agent'
const DEALER_MODEL = MODEL + '/dealer'
const CUSTOMER_MODEL = MODEL + '/customer'

export const registrationApi = {
  agent: {
    requestConfirmation: r('/request-confirmation/', AGENT_MODEL, createSender),
    create: r('/create/', AGENT_MODEL, createSender),
  },
  dealer: {
    requestConfirmation: r('/request-confirmation/', DEALER_MODEL, createSender),
    create: r('/create/', DEALER_MODEL, createSender),
  },
  customer: {
    requestConfirmation: r('/request-confirmation/', CUSTOMER_MODEL, createSender),
    create: r('/create/', CUSTOMER_MODEL, createSender),
  }
}
 